// Which public pages sit next to each other, so every instrument and solution page links to its neighbours
// (real <a href> links that crawlers follow, and visitors use to browse). Slugs match INSTRUMENT_PAGES / SOLUTION_PAGES.
export const INSTRUMENT_GROUPS = {
  "Personality & behaviour": ["disc", "bigfive", "assess", "eq", "belbin", "riasec"],
  "Cognitive & aptitude": ["cab", "iq", "numerical", "verbal", "abstract", "diagrammatic", "mechanical", "attention", "critical_thinking", "verify"],
  "Leadership & development": ["sl", "la", "ftm", "ld", "sjt_management"],
  "Sales & commercial": ["salesaxis", "salesaxis_re", "re_sales", "sjt_sales"],
  "Screeners": ["work_style", "resilience", "integrity", "sjt_customer", "behavioral_fit"],
};

// Solutions most relevant to each group (all exist in SOLUTION_PAGES).
export const GROUP_SOLUTIONS = {
  "Personality & behaviour": ["leadership_dev", "manager_selection", "succession"],
  "Cognitive & aptitude": ["campus", "bpo", "manager_selection"],
  "Leadership & development": ["leadership_dev", "succession", "manager_selection"],
  "Sales & commercial": ["pharma", "bfsi", "bpo"],
  "Screeners": ["bpo", "bfsi", "campus"],
};

// Neighbours of an instrument slug: up to `max` other instruments from its group, and the solutions for that group.
export function relatedForInstrument(slug, max = 5) {
  const group = Object.keys(INSTRUMENT_GROUPS).find(g => INSTRUMENT_GROUPS[g].includes(slug));
  if (!group) return { group: null, instruments: [], solutions: [] };
  return { group, instruments: INSTRUMENT_GROUPS[group].filter(s => s !== slug).slice(0, max), solutions: GROUP_SOLUTIONS[group] };
}

export const SOLUTION_SLUGS = ["bfsi", "bpo", "pharma", "campus", "manager_selection", "leadership_dev", "succession", "feedback360"];
export const FEATURED_INSTRUMENTS = ["disc", "bigfive", "eq", "cab", "sjt_customer"];
